import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

import { LinkContainer } from "react-router-bootstrap";

import './content/content.css';

class Plan extends Component {

	constructor(props) {
		super(props);
		this.renderPricing = this.renderPricing.bind(this);
	}

	signupButton(planName) {
		return (

			<LinkContainer to={"/signup?plan=" + planName}>
		     	<Button bsStyle="success">Sign up</Button>
		     </LinkContainer>
		);
	}

	renderPricing() {		
		if (this.props.promoPrice) {
			return (<div>
				<span style={{textDecoration:'line-through'}}>&nbsp;{this.props.price}&nbsp;</span> <span style={{color: '#C368F6', opacity: 0.95}}>{this.props.promoPrice}</span>
			</div>);
		} else {			
			return (<div>{this.props.price}</div>);
		}
	}

  render() {  	
  	const callToAction = this.props.children ? this.props.children : this.signupButton(this.props.name);

    return (
		<div className={'benefit benefit-plan ' + this.props.className}>
		     <h2>{this.props.name}</h2>
		     <h5 className="pricing">{this.renderPricing()}</h5>
		     <h4>{this.props.subtitle}</h4>
		     <div><h5><small>Data Set</small>{this.props.dataSet}</h5></div>
		     <div><h5><small>Export</small>{this.props.export}</h5></div>
		     {/*<div><h5><small>Depth</small>{this.props.depth}</h5></div>*/}
		     <div><h5><small>Http Headers</small>Included</h5></div>
		     <br/>
		     { callToAction }
		</div>
	);
  }
}

export default Plan;



// WEBPACK FOOTER //
// ./src/Plan.js